import dayjs from '@/common/lib/dayjs';
import proxyClient from '@/common/lib/proxyClient';
import { SCHEDULE_DATE_FORMAT } from '@/widgets/FindAClass/classfinder.constants';
import { ServiceScheduleResponse } from '@/widgets/FindAClass/classfinder.interfaces';

interface FetchServiceScheduleParams {
  clubId: number;
  lang: string;
  start_date: string;
  end_date: string;
  signal?: AbortSignal;
}

export const fetchServiceSchedule = async ({
  lang,
  start_date,
  end_date,
  clubId,
  signal,
}: FetchServiceScheduleParams) => {
  try {
    const { data } = await proxyClient.get('/frontend/service_schedule', {
      params: {
        venue_id: clubId,
        start_date: dayjs(start_date).format(SCHEDULE_DATE_FORMAT),
        end_date: dayjs(end_date).format(SCHEDULE_DATE_FORMAT),
        language: lang,
      },
      headers: {
        'Accept-Language': lang,
      },
      signal,
    });

    return data as ServiceScheduleResponse;
  } catch (error: any) {
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      console.log('Fetch service schedule cancelled');
      return null;
    }

    console.error('Error fetching service schedule:', error);
    return null;
  }
};
